module.exports = __webpack_public_path__ + "img/ic-credit-card-gradient-64-px.2b0b995c.svg";